import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "~/components/ui/button";
import useToast from "~/components/ui/toast";
import { ROUTE_NOVA_VIEW } from "~/router/constants";
import { duplicateAgent, mutateAgentList } from "~/services/agents";

export function useDuplicateAgent() {
  const navigate = useNavigate();
  const { showSuccess, showError } = useToast();

  return useCallback(
    async (agentId: string, displayName: string) => {
      try {
        const duplicate = await duplicateAgent(agentId);
        await mutateAgentList();
        showSuccess(
          `"${displayName}" duplicated`,
          undefined,
          <Button
            variant="link"
            size="sm"
            className="h-auto p-0 text-xs font-medium text-green-700 underline-offset-2 hover:text-green-800"
            onClick={() => navigate(`${ROUTE_NOVA_VIEW}/agents/${duplicate.id}/overview`)}
          >
            View duplicate
          </Button>
        );
      } catch {
        showError("Failed to duplicate agent");
      }
    },
    [navigate, showSuccess, showError]
  );
}
